<template>
  <n-tabs size="large" :tabs-padding="20" v-bind="$attrs">
    <slot />
  </n-tabs>
</template>

<script setup lang="ts">
import { NTabs, type TabsProps } from 'naive-ui'

// regarding "vue-ignore", ref: https://github.com/vuejs/core/issues/8348#issuecomment-1649772297
interface Props extends /* @vue-ignore */ TabsProps {}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.n-tabs.n-tabs--top {
  :deep(.n-tabs-nav) {
    @apply bg-gray-10;
  }
  :deep(.n-tabs-wrapper) {
    @apply w-full md:w-auto;
  }
  :deep(.n-tabs-tab-wrapper) {
    @apply flex-1;
  }
  :deep(.n-tabs-tab) {
    @apply w-full justify-center px-4 py-3 md:py-5;
  }
  :deep(.n-tabs-tab-pad) {
    @apply hidden;
  }
  :deep(.n-tab-pane) {
    @apply pt-0;
  }
}
</style>
